import React from "react";
import { Helmet } from "react-helmet";
import "../styles/legalsites.css";

const Impresszum = () => {
  return (
    <section id="impresszum" className="legal-section">
      <Helmet>
        <title>Impresszum – DentiCare Fogászat</title>
        <meta
          name="description"
          content="A denticare.hu weboldal impresszuma. A fogászati szolgáltató hivatalos adatai, tárhelyszolgáltató és jogi nyilatkozatok."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://denticare.hu/impresszum" />

        <meta property="og:title" content="Impresszum – DentiCare Fogászat" />
        <meta
          property="og:description"
          content="A DentiCare fogászati rendelő hivatalos impresszum adatai és jogi tájékoztatása."
        />
        <meta property="og:url" content="https://denticare.hu/impresszum" />
        <meta property="og:image" content="https://denticare.hu/og.png" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="container d-flex flex-column align-items-center text-center">
        <header className="pt-5 mt-5">
          <h1 className="legal-header">Impresszum</h1>

          <p className="legal-intro">
            Jelen impresszum a denticare.hu weboldal üzemeltetőjének jogi
            adatait és az elektronikus kereskedelmi szolgáltatásokra vonatkozó
            kötelező tájékoztatást tartalmazza.
          </p>
        </header>

        <div className="legal-card">
          <h3>1. Szolgáltató adatai</h3>
          <p>
            <strong>Név:</strong> Re-Vi Dent bt. <br />
            <strong>Székhely:</strong> 5000, Szolnok Tompa Mihály utca 2. <br />
            <strong>Adószám:</strong> 20631064-1-16 <br />
          </p>

          <h3>2. Tárhelyszolgáltató</h3>
          <p>
            <strong>Szolgáltató:</strong> Amazon Web Services (AWS) <br />
            <strong>Székhely:</strong> Seattle, WA, USA <br />
            <strong>Weboldal:</strong>{" "}
            <a href="https://aws.amazon.com" target="_blank" rel="noreferrer">
              https://aws.amazon.com
            </a>
          </p>

          <h3>3. Felelősség kizárása</h3>
          <p>
            A weboldalon megjelenő tartalom tájékoztató jellegű, nem minősül
            orvosi tanácsnak. A pontos diagnózis és kezelés minden esetben
            személyes konzultáció során történik.
          </p>

          <h3>4. Szerzői jog</h3>
          <p>
            A weboldalon található szöveges és képi tartalmak szerzői jogi
            védelem alatt állnak. Azok engedély nélküli felhasználása tilos.
          </p>

          <h3>5. Joghatóság</h3>
          <p>
            A weboldal használatából eredő jogviták esetén a felek a Szolnoki
            Járásbíróság illetékességét kötik ki.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Impresszum;
